import assert from 'minimalistic-assert';
import { isExodusDomain } from './is-exodus-domain.js';
import { parseTraceparent } from './parse-traceparent.js';
const FACTORY_SYMBOL = Symbol('TraceId');
const TraceIdBrand = Symbol.for('Exodus:TraceId');
export class TraceId {
    #value;
    constructor({ initSymbol, value }) {
        assert(initSymbol === FACTORY_SYMBOL, 'TraceId: use static factory methods');
        this.#value = value;
    }
    static [TraceIdBrand] = TraceIdBrand;
    static [Symbol.hasInstance](instance) {
        return instance?.constructor?.[TraceIdBrand] === TraceIdBrand;
    }
    static fromRawTraceparent(traceparent) {
        if (typeof traceparent !== 'string') {
            return;
        }
        const data = parseTraceparent(traceparent);
        if (!data) {
            return;
        }
        return new TraceId({ initSymbol: FACTORY_SYMBOL, value: data.traceId });
    }
    static fromResponse(response) {
        if (!(response instanceof Response)) {
            return;
        }
        if (!isExodusDomain(response.url)) {
            return;
        }
        return TraceId.fromRawTraceparent(response.headers.get('traceparent'));
    }
    toString() {
        return this.#value;
    }
    toJSON() {
        return this.#value;
    }
}
